import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environmentURL } from 'src/environments/environments';

@Injectable({
  providedIn: 'root'
})

export class VistaServices {
  private baseUrl = environmentURL.apiBaseUrl;
  private apiUrl = `${this.baseUrl}consulta`;

  constructor(private http: HttpClient) {}

  // Método para realizar una solicitud GET a la API con el parámetro de vista y condiciones
  getVista(vista: string, keys: string[] = [], values: string[] = []): Observable<{ datos: any[]; formato: any; resumen: any[]; filtro: any[] }> {
    let httpParams = new HttpParams().set('vista', vista);
    
    keys.forEach((key, index) => {
      const value = values[index];

      if (typeof value === 'string' && value.startsWith('BETWEEN')) {
        httpParams = httpParams.set(key, value);
      }else if (typeof value === 'number') {
        httpParams = httpParams.set(key, value);
      } else {
        httpParams = httpParams.set(key, `'${value}'`);
      }

    });

    return this.http.get<any>(`${this.apiUrl}`, { params: httpParams, observe: 'response' })
      .pipe(
        map((response: HttpResponse<any>) => {
          if (response && response.body) {
            
            const { datos, formato, resumen, filtro } = response.body;
            let parsedFormato = [];
            try {
              parsedFormato = JSON.parse(`[${formato}]`);
            } catch (error) {
              console.error('Error al parsear formato:', error);
            }
            let parsedResumen = [];
            try {
              parsedResumen = JSON.parse(`[${resumen}]`);
            } catch (error) {
              console.error('Error al parsear resumen:', error);
            }

            let parsedFiltro = filtro;
            if (typeof filtro === 'string') {
              try {
                parsedFiltro = JSON.parse(filtro);
              } catch (error) {
                console.error('Error al parsear filtro:', error);
                parsedFiltro = [];
              }
            }



            return { datos, formato: parsedFormato, resumen: parsedResumen, filtro: parsedFiltro || [] };
          } else {
            return { datos: [], formato: [], resumen: [], filtro: [] };
          }
        }),
        catchError(this.handleError)
      );
  }

  // Función para manejar errores
  private handleError(error: HttpErrorResponse) {
    
    console.error('Detalles del error:', error);
    
    return throwError('Ha ocurrido un error. Por favor, inténtelo nuevamente más tarde.');
  }
}
